import { Button, Dropdown, Tooltip } from 'antd';
import { BoldOutlined, ItalicOutlined, EllipsisOutlined, UnderlineOutlined, StrikethroughOutlined, AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined, MenuOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var formattingItems = function formattingItems(labels) {
  return [{
    type: 'button',
    tooltip: labels.bold,
    icon: /*#__PURE__*/_jsx(BoldOutlined, {}),
    onClick: function onClick(editor) {
      return editor.chain().focus().toggleBold().run();
    },
    isActive: function isActive(editor) {
      return editor.isActive('bold');
    },
    isDisabled: function isDisabled(editor) {
      return !editor.can().chain().focus().toggleBold().run();
    }
  }, {
    type: 'button',
    tooltip: labels.italic,
    icon: /*#__PURE__*/_jsx(ItalicOutlined, {}),
    onClick: function onClick(editor) {
      return editor.chain().focus().toggleItalic().run();
    },
    isActive: function isActive(editor) {
      return editor.isActive('italic');
    },
    isDisabled: function isDisabled(editor) {
      return !editor.can().chain().focus().toggleItalic().run();
    }
  }, {
    type: 'dropdown',
    tooltip: labels.moreFormatting,
    icon: /*#__PURE__*/_jsx(EllipsisOutlined, {}),
    items: [{
      label: labels.underline,
      icon: /*#__PURE__*/_jsx(UnderlineOutlined, {}),
      onClick: function onClick(editor) {
        return editor.chain().focus().toggleUnderline().run();
      },
      isActive: function isActive(editor) {
        return editor.isActive('underline');
      },
      isDisabled: function isDisabled(editor) {
        return !editor.can().chain().focus().toggleUnderline().run();
      }
    }, {
      label: labels.strike,
      icon: /*#__PURE__*/_jsx(StrikethroughOutlined, {}),
      onClick: function onClick(editor) {
        return editor.chain().focus().toggleStrike().run();
      },
      isActive: function isActive(editor) {
        return editor.isActive('strike');
      },
      isDisabled: function isDisabled(editor) {
        return !editor.can().chain().focus().toggleStrike().run();
      }
    }, {
      label: labels.alignLeft,
      icon: /*#__PURE__*/_jsx(AlignLeftOutlined, {}),
      onClick: function onClick(editor) {
        return editor.chain().focus().setTextAlign('left').run();
      },
      isActive: function isActive(editor) {
        return editor.isActive({
          textAlign: 'left'
        });
      },
      isDisabled: function isDisabled(editor) {
        return !editor.can().chain().focus().setTextAlign('left').run();
      }
    }, {
      label: labels.alignCenter,
      icon: /*#__PURE__*/_jsx(AlignCenterOutlined, {}),
      onClick: function onClick(editor) {
        return editor.chain().focus().setTextAlign('center').run();
      },
      isActive: function isActive(editor) {
        return editor.isActive({
          textAlign: 'center'
        });
      },
      isDisabled: function isDisabled(editor) {
        return !editor.can().chain().focus().setTextAlign('center').run();
      }
    }, {
      label: labels.alignRight,
      icon: /*#__PURE__*/_jsx(AlignRightOutlined, {}),
      onClick: function onClick(editor) {
        return editor.chain().focus().setTextAlign('right').run();
      },
      isActive: function isActive(editor) {
        return editor.isActive({
          textAlign: 'right'
        });
      },
      isDisabled: function isDisabled(editor) {
        return !editor.can().chain().focus().setTextAlign('right').run();
      }
    }, {
      label: labels.justify,
      icon: /*#__PURE__*/_jsx(MenuOutlined, {}),
      onClick: function onClick(editor) {
        return editor.chain().focus().setTextAlign('justify').run();
      },
      isActive: function isActive(editor) {
        return editor.isActive({
          textAlign: 'justify'
        });
      },
      isDisabled: function isDisabled(editor) {
        return !editor.can().chain().focus().setTextAlign('justify').run();
      }
    }]
  }];
};

export var FormattingMenu = function FormattingMenu(_ref) {
  var editor = _ref.editor,
      labels = _ref.labels;
  var items = formattingItems(labels);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: items.map(function (item, index) {
      switch (item.type) {
        case 'button':
          return /*#__PURE__*/_jsx(Tooltip, {
            title: item.tooltip,
            children: /*#__PURE__*/_jsx(Button, {
              icon: item.icon,
              onClick: function onClick() {
                return item.onClick(editor);
              },
              disabled: item.isDisabled ? item.isDisabled(editor) : false,
              type: item.isActive ? item.isActive(editor) ? 'primary' : 'text' : 'text'
            })
          }, index);

        case 'dropdown':
          return /*#__PURE__*/_jsx(Tooltip, {
            title: item.tooltip,
            children: /*#__PURE__*/_jsx(Dropdown, {
              trigger: ['click'],
              menu: {
                items: item.items.map(function (dropdownItem, dropdownIndex) {
                  return {
                    label: /*#__PURE__*/_jsx(Button, {
                      icon: dropdownItem.icon,
                      disabled: dropdownItem.isDisabled ? dropdownItem.isDisabled(editor) : false,
                      type: dropdownItem.isActive ? dropdownItem.isActive(editor) ? 'primary' : 'text' : 'text',
                      children: dropdownItem.label
                    }),
                    key: dropdownIndex,
                    onClick: function onClick() {
                      return dropdownItem.onClick(editor);
                    }
                  };
                })
              },
              children: item.icon
            })
          }, index);

        default:
          return null;
      }
    })
  });
};